import { AppRoute } from 'constants/AppRoute';
import { TestLocators } from 'constants/Locators';

import { MUI, ThemeMode } from 'ci-esi-web-shared';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { log } from 'services/log';
import { LogEvent } from 'services/LogEvent';
import { LogSource } from 'services/LogSource';
import { colors } from 'styles/theme/colors';

export function Logo() {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    log.info({
      event: LogEvent.CLICK,
      source: LogSource.LANDING_PAGE,
    });
    navigate(AppRoute.ROOT);
  };

  return (
    <MUI.Box
      sx={{
        height: 64,
        paddingLeft: '12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: { marginRight: '5px' },
      }}
    >
      <MUI.Typography
        onClick={handleClick}
        data-testid={TestLocators.GoTo_LandingPage}
        sx={{
          lineHeight: '26px',
          font: 'normal 24px "Akkurat", Arial, sans-serif',
          fontWeight: 700,
          color: isDarkMode ? colors.smokeScreen : colors.textPrimaryDefault,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {t('COMMON.TITLE')}
      </MUI.Typography>
    </MUI.Box>
  );
}
